import { MutationTree } from 'vuex';
import { IProjectListState } from '@/store/interfaces';
import { ProjectDto } from '@/dto/Projects.dto';

export const mutations: MutationTree<IProjectListState> = {
  SET_PROJECT_LIST(state, payload: ProjectDto[]) {
    state.projectList = payload;
  },
};
